export default __webpack_public_path__ + "static/media/zip.acd3be21.svg";